module.exports = __webpack_public_path__ + "static/img/MGAVGimg.92dd90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MGAVGimg.png
// module id = zgEu
// module chunks = 1